export enum UserClass {
    NotSet = 0,
    Bronze = 1,
    Silver = 2,
    Gold = 3
}
